import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.homes';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet Hub',
  url: `${siteUrl}/`,
  description: 'The ultimate shopping spreadsheet database and research platform for product discovery, comparison, and organization.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Hipobuy Spreadsheet Hub',
  url: `${siteUrl}/`,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
  description: 'The ultimate shopping spreadsheet database and research platform.',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}